module.exports = __webpack_public_path__ + "img/lamp.8c93aa26.svg";